import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { DOCUMENT_TYPE_PATH } from '../../../../config/paths';
import DocumentTypeDeleteButton from './DocumentTypeDeleteButton';

const DocumentTypeToolbar = ({ documentTypeId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${DOCUMENT_TYPE_PATH}/${documentTypeId}/edit`} />{' '}
      <DocumentTypeDeleteButton documentTypeId={documentTypeId} />
    </div>
  </ButtonToolbar>
);

DocumentTypeToolbar.propTypes = {
  documentTypeId: PropTypes.number.isRequired,
};

export default DocumentTypeToolbar;